import lo, { map, find, values, sortBy } from 'lodash';
import defaultAssessments from '../../config/assessments';

import {
  setUser,
  getUserFromDB,
  initAppComplete,
  setActiveVisit,
  setUpcomingVisit,
  setCurrentVisit,
  setHistory,
  sortVisits,
  sortActiveReports,
  setActiveReport,
  getActiveAssessments,
  setActiveAssessments,
  setSurveysLastModifiedOn,
  initApp,
  setActiveAssessment,
  setSortedAssessments,
  setSurveysLastCompletedAt,
  setSurveysLastUpdatedAt
} from './actions';

import store, { dispatch } from '../../root/store';
import { apiRequest } from '../../api/actions';
import { sortNav, highlightNavbarSection, changeRoute } from '../Nav/actions';
import {
  formatVisit,
  filterMissedVisits,
  addTitleToReports,
  extendAssessments,
  titleCase
} from '../../utils';

import { USER_URL, VISIT_URL, ASSESSMENTS_URL } from '../../api/endpoints';

import {
  GET_USER_FROM_DB,
  GET_USER_FROM_DB_AND_UPDATE_STORE,
  INIT_APP,
  SET_USER,
  SET_ACTIVE_VISIT,
  SORT_VISITS,
  SORT_ACTIVE_REPORTS,
  GET_ACTIVE_ASSESSMENTS,
  CHECK_IF_MOBILE,
  SET_PROGRESS_BAR_PERCENT,
  LOGOUT
} from './action-types';

import config from '../../config/app';
import EyeIcon from '../../assets/icons/nav_bar/current_report.svg';
import { desktopBreakpoint } from '../../constants';

const middleware = () => next => action => {
  switch (action.type) {
    case INIT_APP: {
      const meta = {
        Component: 'App',
        ignoreAuth: true,
        onSuccess: result => {
          const user = result.data.data;
          dispatch(setUser(user));
        },
        onError: error => {
          // Initialize app even on 401 error
          console.log(error);
          dispatch(initAppComplete());
        }
      };
      dispatch(getUserFromDB(meta));
      return next(action);
    }

    case GET_USER_FROM_DB_AND_UPDATE_STORE: {
      const meta = {
        onSuccess: result => {
          dispatch(setUser(result.data.data));
          if (action.meta && action.meta.onSuccess) {
            action.meta.onSuccess(result.data.data);
          }
        }
      };
      dispatch(getUserFromDB(meta));
      return next(action);
    }

    case GET_USER_FROM_DB: {
      const request = {
        url: USER_URL,
        method: 'get'
      };
      dispatch(apiRequest(request, action.meta));
      return next(action);
    }

    case SET_USER: {
      // Force titlecase to user name
      if (action.payload) {
        const user = { ...action.payload };
        user.first_name = titleCase(user.first_name);
        user.last_name = titleCase(user.last_name);
        user.full_name = titleCase(user.full_name);
        const visits = filterMissedVisits(user.visits);
        user.visits = visits;
        dispatch(sortVisits(action?.payload?.visits));
      }

      return next(action);
    }

    case SET_PROGRESS_BAR_PERCENT: {
      const { app } = store.getState().containers;
      const progressBarPercent = app.get('progressBarPercent');

      if (!app.get('isMobile')) return;
      if (Math.floor(action.payload) === progressBarPercent) return;
      else {
        action.payload = Math.floor(action.payload);
        return next(action);
      }
    }

    // case LOGOUT: {
    //   next(action);
    //   dispatch(changeRoute({ route: '/phone' }));
    //   dispatch(initApp());
    //   if (action.meta && action.meta.actionAfterLogout) {
    //     dispatch(action.meta.actionAfterLogout());
    //   }
    //   return;
    // }

    case GET_ACTIVE_ASSESSMENTS: {
      const request = {
        method: 'get',
        url: ASSESSMENTS_URL
      };

      const onSuccess = result => {
        const assessments = result.data.data;
        let extendedAssessments = extendAssessments(assessments);
        const payload = {};
        const meta = {};
        // delete extendedAssessments.consent;
        lo.map(extendedAssessments, (assessment, index) => {
          if (typeof assessment !== 'string') {
            assessment._meta = {};
            // assessment._meta.visitId = action.meta.visitId;
            // assessment._meta.route = `/visits/${action.meta.visitId}/assessments/${assessment.shortName}`;
            // assessment._meta.Component = assessment.title.replace(/ /, '');
            assessment._meta.route = `/landing/assessments/${assessment.shortName}`;
            assessment.steps = map(
              defaultAssessments[assessment.shortName]?.steps,
              step => {
                let existingStep = find(assessment.steps, [
                  'stepId',
                  step.stepId
                ]);
                if (existingStep) {
                  existingStep.questions = step.questions;
                } else {
                  existingStep = step;
                }
                return existingStep;
              }
            );

            // const shouldSetActiveAssessment =
            //   action.meta &&
            //   action.meta.activeAssessment &&
            //   assessment.shortName === action.meta.activeAssessment;

            // if (shouldSetActiveAssessment) {
            //   meta.activeAssessment = assessment;
            //   dispatch(setActiveAssessment(assessment));
            // }

            payload[assessment.shortName] = assessment;
          }
        });

        let surveys = values(payload);
        surveys = sortBy(surveys, ['order']);
        if (surveys.length > 8) surveys.shift();
        dispatch(setSortedAssessments(surveys));
        dispatch(setActiveAssessments(payload));
        dispatch(
          setSurveysLastCompletedAt(assessments?.surveysLastCompletedAt)
        );
        dispatch(setSurveysLastUpdatedAt(assessments?.surveysLastUpdatedAt));
        dispatch(setSurveysLastModifiedOn(assessments?.surveysLastModifiedOn));
        dispatch(sortNav());
        if (action.meta.onSuccess) action.meta.onSuccess(payload, meta);
      };

      const meta = {
        Component: 'Assessments',
        onSuccess,
        onError: error => console.log('get assessments error', error)
      };

      dispatch(apiRequest(request, meta));
      return next(action);
    }

    case SORT_ACTIVE_REPORTS: {
      let reports = action.payload.reportCard;
      const visitId = action.payload.uuid;

      reports = addTitleToReports(reports);

      const payload = {};
      let index = 0;
      lo.forEach(reports, (report, key) => {
        if (config.reports.includes(report._meta.title)) {
          const { originalTitle } = report._meta;
          report._meta.visitId = visitId;
          report._meta.index = index; // to move through them on mobile with next btn
          report._meta.route = `/visits/${visitId}/reports/${originalTitle}`;
          report._meta.Component = report._meta.title.replace(/ /, '');
          // set default active report if on that route
          const shouldSetActiveReport =
            action.meta &&
            action.meta.setActiveReport &&
            originalTitle === action.meta.activeReport;

          if (shouldSetActiveReport) dispatch(setActiveReport(report));
          payload[originalTitle] = report;
          index++;
        }
      });

      action.payload = payload;
      return next(action);
    }

    case SET_ACTIVE_VISIT: {
      if (action.payload === null) return next(action); // just go set it to null

      const visit = action.payload.data.data;
      const { uuid, date, reportPdf, status, reportCard } = visit;

      const {
        formattedDate,
        longFormattedDate,
        dayFormattedDate,
        title,
        subTitle,
        route
      } = formatVisit(visit);

      const sortedReports = addTitleToReports(reportCard);

      const payload = {
        uuid,
        date,
        formattedDate,
        longFormattedDate,
        dayFormattedDate,
        title,
        subTitle,
        route,
        reportPdf,
        status,
        reportCard: sortedReports
      };

      dispatch(sortActiveReports(payload, action.meta));
      if (
        action.meta &&
        (action.meta.setActiveAssessment || action.meta.getActiveAssessments)
      ) {
        dispatch(
          getActiveAssessments(payload, {
            visitId: uuid,
            activeAssessment: action.meta.activeAssessment,
            onSuccess: action.meta.onSuccess
          })
        );
      }

      action.payload = payload;

      return next(action);
    }

    case SORT_VISITS: {
      const rawVisits = action.payload;
      const history = {};
      const historyList = []; // to keep visits in order of date to find currentVisit
      let upcomingVisit = null;

      // filter missed appointments
      const visits = filterMissedVisits(rawVisits);

      visits.map((visit, index) => {
        const { date, uuid, status } = visit;
        const {
          formattedDate,
          longFormattedDate,
          dayFormattedDate,
          title,
          subTitle,
          route
        } = formatVisit(visit);

        const item = {
          date,
          uuid,
          status,
          title,
          formattedDate,
          dayFormattedDate,
          longFormattedDate,
          subTitle
        };

        const isUpcoming = !status.completed;

        if (isUpcoming) {
          upcomingVisit = item;
          upcomingVisit.route = '/';
        } else {
          const onClick = () => {
            // dispatch(highlightNavbarSection('history'))
            const request = {
              url: `${VISIT_URL}/${uuid}`,
              method: 'get'
            };

            const meta = {
              Component: 'App',
              assert: {
                item: uuid,
                test: 'isString',
                hasError: false,
                error: null
              },
              onSuccess: result => {
                dispatch(setActiveVisit(result, action.meta));
              },
              onBeforeRequest: () => {
                dispatch(setActiveVisit(null));
              }
            };

            dispatch(apiRequest(request, meta));
          };

          const { reportPdf, status, reportCard } = visit;
          const historyItem = {
            ...item,
            onClick,
            reportPdf,
            status,
            route,
            reportCard
          };

          if (status.completed) {
            history[uuid] = historyItem;
            historyList.push(historyItem);
          }
        }
        return false;
      });

      // const sortedVisits = lo.sortBy(history, 'date').reverse()

      dispatch(setHistory(history));
      dispatch(setUpcomingVisit(upcomingVisit));

      // check if there are any complete visits, if so make a clone and the title for the nav bar

      const currentVisit = lo.find(historyList.reverse(), {
        status: { completed: true }
      });

      let currentVisitClone = null;

      if (currentVisit) {
        currentVisitClone = lo.cloneDeep(currentVisit);

        const request = {
          url: `${VISIT_URL}/${currentVisitClone.uuid}`,
          method: 'get'
        };

        const meta = {
          Component: 'App',
          assert: {
            item: currentVisitClone.uuid,
            test: 'isString',
            hasError: false,
            error: null
          },
          onError: () => {
            if (!store.getState().containers.app.get('isInit')) {
              dispatch(initAppComplete());
            }
          },
          onSuccess: result => {
            const visit = result.data.data;
            const reports = addTitleToReports(visit.reportCard);
            const subItems = {};
            currentVisitClone.route = `/visits/${visit.uuid}/reports`;
            currentVisitClone.title = 'Current Report';
            currentVisitClone.icon = { src: EyeIcon };
            currentVisitClone.onClick = () =>
              dispatch(highlightNavbarSection('currentReport'));

            lo.forEach(reports, (value, key) => {
              const report = {
                title: value._meta.title,
                route: `/visits/${visit.uuid}/reports/${value._meta.originalTitle}`,
                icon: value._meta.icon,
                hideOnMobile: true
              };
              if (config.reports.includes(value._meta.title)) {
                subItems[value._meta.title] = report;
              }
            });
            currentVisitClone.subItems = subItems;
            dispatch(setCurrentVisit(currentVisitClone));
            dispatch(sortNav());
            setTimeout(() => {
              if (!store.getState().containers.app.get('isInit')) {
                dispatch(initAppComplete());
              }
            }, 1000);
          }
        };
        dispatch(apiRequest(request, meta));
      } else {
        setTimeout(() => {
          if (!store.getState().containers.app.get('isInit')) {
            dispatch(initAppComplete());
          }
        }, 1000);
      }

      return next(action);
    }

    case CHECK_IF_MOBILE: {
      const isMobile = window.innerWidth < desktopBreakpoint;
      action.payload = isMobile;
      return next(action);
    }

    default: {
      return next(action);
    }
  }
};

export default middleware;
